// @flow
import * as React from 'react';
import styled from 'styled-components';
import Paging from '../domain/paging';

const StyledInput = styled.input`
  width: 32px;
  margin: 0 ${({ theme: { V2 } }) => V2.metrics.margin.small}px;
`;

type PageSelectionProps = {
  paging: Paging,
  onCurrentPageChange: (page: number) => void,
}

type PageSelectionState = {
  currentPage: string,
}

export class PaginationInput extends React.Component<PageSelectionProps, PageSelectionState> {
  state = { currentPage: String(this.props.paging.currentPage) };

  componentDidUpdate(prevProps: PageSelectionProps) {
    if (!this.props.paging.isSameAs(prevProps.paging)) {
      this.changeCurrentPageValue(this.props.paging.currentPage);
    }
  }

  changeCurrentPageValue = (value: any) => {
    this.setState({ currentPage: String(value) });
  };

  onCurrentPageValueChange = (event: any) => {
    this.changeCurrentPageValue(event.target.value);
  };

  onCurrentPageChange = () => {
    const currentPage = this.parseCurrentPageValue();
    this.changeCurrentPageValue(currentPage);

    const { paging, onCurrentPageChange } = this.props;
    if (paging.canGoTo(currentPage)) {
      onCurrentPageChange(currentPage);
    }
  };

  parseCurrentPageValue = () => {
    const { currentPage } = this.state;

    const parsedCurrentPage = Number.parseInt(currentPage, 10);
    if (Number.isNaN(parsedCurrentPage)) {
      return this.props.paging.currentPage;
    }

    return parsedCurrentPage;
  };

  render() {
    const { currentPage } = this.state;

    return (
      <StyledInput
        type="text"
        value={currentPage}

        onChange={this.onCurrentPageValueChange}
        onBlur={this.onCurrentPageChange}
      />
    );
  }
}

export default PaginationInput;



// WEBPACK FOOTER //
// ./src/statsradio/modules/pagination/components/PaginationInput.js